<template lang="pug">
.field
  el-form
    el-form-item(label='Title')
      el-input(v-model='field.title' :disabled='disabled')

    el-form-item(label='Description')
      el-input(v-model="field.properties.description.value" :disabled='disabled')

</template>

<script>
export default {
  props: {
    field: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="scss"></style>
